"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * Passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
exports.default = setRef;
//# sourceMappingURL=setRef.js.map